const limitLine = (element) => {
	const link = element;
	const textLink = [link.textContent, 'Скрыть'];
	const line = link?.getAttribute('data-limit-line');
	const id = {
		container: link?.getAttribute('data-limit-line-container'),
		item: link?.getAttribute('data-limit-item'),
	}
	const container = document.querySelector(id.container);
	const items = container?.querySelectorAll(id.item);

	if(!container || !items.length) return;

	const hiddenBtn = () => {
		if(items.length <= line) {
			link.classList.add('d-none');
		}
	}
	const setInitHeight = () => {
		const heightContainer = items.length > line ? items[0].clientHeight * line : container.clientHeight;
		container.style.height = `${heightContainer}px`;
	}
	const setHeight = () => {
		if(container.scrollHeight > container.clientHeight) {
			container.style.height = `${container.scrollHeight}px`;
		} else {
			setInitHeight();
		}
	}
	const setTextLink = () => {
		if(link.textContent === textLink[0]) {
			link.textContent = textLink[1];
		} else {
			link.textContent = textLink[0];
		}
	}

	const init = () => {
		hiddenBtn();
		setInitHeight();

		link.onclick = (e) => {
			e.preventDefault();
			setHeight();
			setTextLink();
		}
	}

	init();
}

document.addEventListener('DOMContentLoaded', () => {
	const element = document.querySelectorAll('[data-limit-line]');
	if(!element.length) return;
	element.forEach(el => limitLine(el));
})
